import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import React, {ReactNode, useRef, useState} from "react"

import styles from "./BasicAccordionItem.module.scss"

export type BasicAccordionItemType = {question: string; answer: string}

type Props = {
	children: ReactNode
	title: string
}

const BasicAccordionItem = (props: Props) => {
	const [active, setActive] = useState<boolean>(false)

	const handleItemClick = () => {
		setActive(!active)
	}
	const contentEl = useRef<HTMLDivElement>(null)

	return (
		<div
			className={styles.accordionRow}
			itemProp={"mainEntity"}
			itemType={"https://schema.org/Question"}
			itemScope
		>
			<div
				className={`${styles.accordionQuestion} ${styles.studio} ${
					styles.button
				}  ${styles.expand}  ${
					active ? styles.active : styles.unActive
				}`}
				data-testid={"BasicAccordionItemButton"}
				onClick={() => handleItemClick()}
			>
				<Paragraph
					className={styles.buttonTitle}
					content={props.title}
					fontWeight={600}
					itemProp={"name"}
					size={"S"}
				/>
			</div>
			<div
				ref={contentEl}
				className={`${styles.accordionAnswert} ${styles.insideText} ${
					active ? styles.listEnterActive : styles.listExitActive
				}`}
				data-testid={"BasicAccordionItemBody"}
				style={
					active
						? {height: contentEl.current?.scrollHeight}
						: {height: "0px"}
				}
			>
				{props.children}
			</div>
		</div>
	)
}

export default BasicAccordionItem
